import classNames                                         from 'classnames';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import DV                                                 from 'ts-data-validator';
import { useTranslation }                                 from 'react-i18next';

import '../styles.scss';

import { staticPageConstants } from '../../../../common/constants/staticPageConstants';

import { useRouter } from '../../../../common/hooks/useRouter';
import Meta          from '../../../components/meta';
import PageHeader    from '../../../components/pageHeader';

import { RenderBasicTabs } from '../../../components/tabs/RenderBasicTabs';
import RenderHeaderTabs    from '../../../components/tabs/RenderHeaderTabs';
import { useCommon }       from '../../../providers/common';
import { useTab }          from '../../../providers/tabs';
import renderStaticSection from '../../_common/utils/renderStaticSection';

import StaticContent from './StaticContent';

const Static = function() {
  const { pages } = useCommon();
  const {
          history,
          match: {
                   params: {
                             page: section,
                           },
                 },
        }         = useRouter();
  const {
          registerTabsComponent,
          changeTab,
        }         = useTab();
  const { t }     = useTranslation();

  const node = useRef(null);
  let tabs   = {};

  const currentPage = useMemo(() => {
    return pages.find((page) => page.urlKey === section);
  }, [pages, section]);

  const activeTab = useMemo(() => {
    return currentPage.template.endsWith('_interior') ? 1 : 0;
  }, [currentPage]);

  const tabsPages = useMemo(() => {
    const pageTemplate = currentPage.template.replace(/_interior/gi, '');

    if (pages.some((page) => page.template === `${pageTemplate}_interior`)) {
      return pages.filter((page) => {
        const regex = new RegExp(`^${pageTemplate}(_interior)?$`, 'i');

        return regex.test(page.template);
      });
    }

    return [currentPage];
  }, [currentPage, pages]);

  const {
          content: Content,
          headImage,
        }           = currentPage;
  const headerProps = {
    transparent: false,
  };

  if (DV.isString(headImage)) {
    headerProps.transparent = true;
    headerProps.bg          = headImage;
  }

  const {
          label,
          meta,
        } = currentPage;

  const changeHeaderTabs = useCallback((tabsType, index) => {
    if (node.current) {
      if (tabsType === staticPageConstants.PAGE_TYPE.TABS_WITH_SCROLLING && tabs[index]) {
        const nav      = node.current.ownerDocument.getElementById('nav')
          .getBoundingClientRect();
        const header   = node.current.ownerDocument.getElementById('header')
          .getBoundingClientRect();
        const position = tabs[index].getBoundingClientRect();

        if (!isSSR()) {
          scrollTo({
            top:      position.top - nav.height - header.height,
            left:     0,
            behavior: 'smooth',
          });
        }
      }
    }
  }, [node.current, staticPageConstants, tabs]);

  const renderSections = useCallback(({
    PAGE_TYPE,
    SECTIONS,
  }) => {
    if (PAGE_TYPE === staticPageConstants.PAGE_TYPE.STATIC_PAGE) {
      return SECTIONS.map((section, index) => renderStaticSection(section, index));
    }

    return SECTIONS.map((tab, index) => {
      return ((
        <div
          ref={(node) => {
            if (!tabs.hasOwnProperty(index)) {
              tabs[index] = node;
            }
          }}
          key={index}
        >
          {tab.map((section, index) => renderStaticSection(section, index))}
        </div>
      ));
    });
  }, [staticPageConstants, renderStaticSection, tabs]);

  const handleChangeTab = useCallback((index) => {
    if (index !== activeTab) {
      if (currentPage.template.endsWith('_interior')) {
        const page = tabsPages.find((page) => page.template === currentPage.template.replace(/_interior/gi, ''));

        history.push(`/${page.urlKey}`);
      } else {
        const page = tabsPages.find((page) => page.template === `${currentPage.template}_interior`);

        history.push(`/${page.urlKey}`);
      }

      changeTab(currentPage.template.replace(/_interior$/gi, ''), index);
    }
  }, [activeTab, currentPage, history, tabsPages]);

  useEffect(() => {
    if (DV.isNull(activeTab)) {
      registerTabsComponent(currentPage.template.replace(/_interior$/gi, ''));
    }
  }, []);

  try {
    const {
            PAGE_TYPE,
            PAGE_TABS,
          } = JSON.parse(Content);
    if (PAGE_TYPE !== staticPageConstants.PAGE_TYPE.STATIC_PAGE) {
      headerProps.doubleBtns = (
        <RenderHeaderTabs
          nav={PAGE_TABS.map(label => ({ label }))}
          onChange={(index) => changeHeaderTabs(PAGE_TYPE, index)}
          active={0}
        />
      );
    }
  } catch (error) {
  }

  return (
    <div
      ref={node}
      className={classNames('page-content', 'static-page-content', { without_tabs: tabsPages.length <= 1 })}
    >
      <Meta {...meta} />
      {DV.isNotEmptyString(label) && !headerProps.transparent && (
        <PageHeader {...headerProps}>{label}</PageHeader>
      )}
      <RenderBasicTabs
        active={activeTab}
        changeTab={handleChangeTab}
        className={classNames({ full_screen_tabs: headerProps.transparent })}
        forceTabs
        nav={[
          { label: t('entrance_doors') },
          { label: t('interior_doors') },
        ]}
      >
        {DV.isArray(tabsPages) && tabsPages.map((_, index) => {
          if (activeTab === index) {
            return (
              <StaticContent
                headerProps={headerProps}
                key={index}
                label={label}
                renderSections={renderSections}
              />
            );
          }
        })}
      </RenderBasicTabs>
    </div>
  );
};
export default Static;